export default __webpack_public_path__ + "static/media/background.a91ac8d2.jpeg";